import { Inject, Injectable, Optional } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NK_PARSER_DICTIONARY } from '@nitro/core/common';
import * as _moment from 'moment';
// eslint-disable-line no-duplicate-imports
// eslint-disable-next-line no-duplicate-imports
import { Moment } from 'moment';
import {
  NK_DEFAULT_RANGE_DATE_TIME_PARSERS,
  NK_RANGE_DATE_TIME_PARSERS
} from '../parsers/range-date-time.parsers';
import { DateTimeAdapter } from './date-time-adapter';
import { RangeDateTimeAdapter } from './range-date-time-adapter';
import { DateTimeRange } from '../types';

const moment = _moment;

@Injectable()
export class NkMomentRangeDateTimeAdapter extends RangeDateTimeAdapter<Moment> {
  constructor(
    private _dateAdapter: DateTimeAdapter<Moment>,
    @Optional() @Inject(MAT_DATE_LOCALE) dateLocale?: string,
    @Optional()
    @Inject(NK_RANGE_DATE_TIME_PARSERS)
    private rangeDict?: NK_PARSER_DICTIONARY<DateTimeRange<Moment>>
  ) {
    super();
    // this.rangeDict = this.rangeDict || NK_DEFAULT_RANGE_DATE_TIME_PARSERS;
    this.dateTimeAdapter = this._dateAdapter;

    // Object.getOwnPropertyNames(RangeDateTimeAdapter.prototype).forEach(name => {
    //   Object.defineProperty(
    //       this, name, Object.getOwnPropertyDescriptor(RangeDateTimeAdapter.prototype, name));
    // });
  }

  parse = (
    value: string,
    parseFormat: string | string[],
    separator = '-'
  ): DateTimeRange<Moment> | null => {
    if (value && this.rangeDict) {
      for (const xp of Array.from(this.rangeDict.values())) {
        const mxp = xp(value.trim(), this.locale);
        if (mxp && this.isValidRange(mxp)) {
          return mxp;
        }
      }

      const dates = value.split(separator);

      const startDate = this.dateTimeAdapter.parse(dates[0], parseFormat);
      const endDate = this.dateTimeAdapter.parse(dates[1], parseFormat);
      if (
        this.dateTimeAdapter.isDateInstance(startDate) &&
        this.dateTimeAdapter.isDateInstance(endDate)
      ) {
        return { start: startDate, end: endDate };
      } else {
        return null;
      }
    }
  };
}
